/* BANGE COD: readiness, visible totals and a success-only Clarity funnel. */
(() => {
  'use strict';
  const normalizePhone = (value) => {
    const compact = String(value).trim().replace(/[\s().-]/g, '');
    const local = compact.replace(/^(?:\+216|00216|216)(?=\d{8}$)/, '');
    return /^\d{8}$/.test(local) ? local : value;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { normalizePhone };
  if (typeof document === 'undefined') return;

  const track = (event) => {
    if (typeof window.clarity !== 'function') return false;
    window.clarity('event', event);
    return true;
  };
  const trackedOrders = new Set();
  const previousSuccess = window.es_hook_purchase_success;
  // EasySell calls this hook only in afterShopifyOrderCreated, after API success.
  // Send no names, phone numbers, addresses, values or order identifiers to Clarity.
  window.es_hook_purchase_success = function (order) {
    try {
      const id = order?.id || order?.order_number;
      if (id && !trackedOrders.has(String(id))) {
        const key = 'bange-cod-purchase:' + id;
        let recorded = false;
        try { recorded = sessionStorage.getItem(key) === '1'; } catch (_) { /* storage may be disabled */ }
        if (!recorded && track('bange_cod_purchase')) {
          try { sessionStorage.setItem(key, '1'); } catch (_) { /* optional deduplication */ }
          recorded = true;
        }
        if (recorded) trackedOrders.add(String(id));
      }
    } finally {
      if (typeof previousSuccess === 'function') previousSuccess.apply(this, arguments);
    }
  };

  let started = false;
  document.addEventListener('input', (event) => {
    if (!started && event.target.matches('#es-first_name, #es-phone, #es-address, #es-city') && event.target.value.trim()) {
      started = true;
      track('bange_cod_form_started');
    }
  }, true);

  // Preserve the merchant's popup flow and recover taps while EasySell initializes.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-bange-open-order]');
    const popup = event.target.closest('#es-popup-button, .es-popup-button');
    if (!link && !popup) return;
    const popupReady = () => typeof window.openTysloForm === 'function' && document.querySelector('#es-form');
    if (popup && popupReady()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const trigger = link || popup;
    if (trigger.dataset.bangeWaiting) return;
    trigger.dataset.bangeWaiting = 'true';
    trigger.dataset.bangeLoading = 'true';
    trigger.setAttribute('aria-busy', 'true');
    const label = link || trigger.querySelector('.es-button-title');
    const original = label?.textContent;
    if (label) label.textContent = 'Chargement du formulaire…';
    const deadline = Date.now() + 10000;
    const finish = () => {
      delete trigger.dataset.bangeWaiting;
      delete trigger.dataset.bangeLoading;
      trigger.removeAttribute('aria-busy');
      if (label) label.textContent = original;
    };
    const openWhenReady = () => {
      const target = popup || document.querySelector('#product-content #es-popup-button, #product-content .es-popup-button');
      if (popupReady() && target) {
        finish();
        target.click();
      } else if (link && document.querySelector('#es-form')?.getBoundingClientRect().height > 0 && !target) {
        finish();
        document.querySelector('#es-form').scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (Date.now() < deadline) {
        setTimeout(openWhenReady, 100);
      } else {
        finish();
        if (label) label.textContent = 'Réessayez d’ouvrir le formulaire';
      }
    };
    openWhenReady();
  }, true);
  document.addEventListener('blur', (event) => {
    const input = event.target;
    if (!input.matches('#es-phone')) return;
    const normalized = normalizePhone(input.value);
    if (normalized !== input.value) {
      input.value = normalized;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }, true);

  // Handle a filter tap made before Bootstrap's deferred script finishes.
  document.addEventListener('click', (event) => {
    const details = event.target.closest('[data-bange-details]');
    if (details) {
      const panel = document.getElementById(details.getAttribute('href').slice(1));
      if (panel && window.bootstrap?.Collapse) {
        bootstrap.Collapse.getOrCreateInstance(panel, { toggle: false }).show();
      }
    }
    const trigger = event.target.closest('[data-bs-target="#offcanvas-filters"]');
    if (!trigger || window.bootstrap?.Offcanvas) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (trigger.dataset.bangeLoading) return;
    trigger.dataset.bangeLoading = 'true';
    trigger.setAttribute('aria-busy', 'true');
    const label = trigger.querySelector('span');
    const previousLabel = label?.textContent;
    if (label) label.textContent = 'Chargement des filtres…';
    const deadline = Date.now() + 10000;
    const waitForFilters = () => {
      if (window.bootstrap?.Offcanvas) {
        delete trigger.dataset.bangeLoading;
        trigger.removeAttribute('aria-busy');
        if (label) label.textContent = previousLabel;
        bootstrap.Offcanvas.getOrCreateInstance(document.querySelector('#offcanvas-filters')).show();
      } else if (Date.now() < deadline) {
        setTimeout(waitForFilters, 100);
      } else {
        delete trigger.dataset.bangeLoading;
        trigger.removeAttribute('aria-busy');
        if (label) label.textContent = 'Filtres indisponibles — réessayez';
      }
    };
    waitForFilters();
  }, true);

  const initialize = () => {
    const form = document.querySelector('#product-content');
    if (!form) return;
    const summary = form.querySelector('[data-bange-order-summary]');
    const summaryTotal = summary?.querySelector('[data-bange-delivered-total]');
    let readyTracked = false;
    let frame = 0;
    let bundlesConnected = false;
    let observedApp = null;
    const syncEstimate = () => {
      if (!summaryTotal) return;
      const productForm = summary.closest('form');
      const unitPrice = Number(productForm?.querySelector('[name="id"]')?.dataset.price || summary.dataset.productPrice);
      const quantity = Math.max(1, parseInt(productForm?.querySelector('[name="quantity"]')?.value, 10) || 1);
      const addons = [...(productForm?.querySelectorAll('input[name="bundles"]:checked') || [])]
        .reduce((total, input) => total + (Number(input.dataset.price) || 0), 0);
      const price = unitPrice * quantity + addons + Number(summary.dataset.deliveryFee);
      if (Number.isFinite(price)) {
        const text = (price / 100).toFixed(3) + ' DT';
        if (summaryTotal.textContent !== text) summaryTotal.textContent = text;
      }
    };
    form.addEventListener('change', () => requestAnimationFrame(syncEstimate));
    const connectBundles = () => {
      const helpers = window.EasySellHelpers;
      if (bundlesConnected || !helpers?.getBundlesAppUpdates) return;
      const original = helpers.getBundlesAppUpdates;
      helpers.getBundlesAppUpdates = function () {
        const existing = original.apply(this, arguments);
        if (existing?.length) return existing;
        const productForm = form.querySelector('.product-bundle')?.closest('form');
        const variantId = productForm?.querySelector('[name="id"]')?.value;
        if (!variantId) return existing;
        // EasySell observes native checkbox/select changes and requests these items.
        // Returning the main item after deselection also removes old add-ons.
        const quantity = Math.max(1, parseInt(productForm.querySelector('[name="quantity"]')?.value, 10) || 1);
        const items = [{ id: Number(variantId), quantity }];
        productForm.querySelectorAll('input[name="bundles"]:checked').forEach(input => {
          if (!input.disabled && /^\d+$/.test(input.value)) items.push({ id: Number(input.value), quantity: 1 });
        });
        return items;
      };
      bundlesConnected = true;
    };
    const sync = () => {
      connectBundles();
      const app = document.querySelector('#easysell');
      if (app && app !== observedApp) {
        observer.observe(app, { childList: true, subtree: true, characterData: true });
        observedApp = app;
        insertionObserver.disconnect();
      }
      const button = document.querySelector('#es-form-button');
      const total = button?.querySelector('.es-total-placeholder');
      const ready = Boolean(total && /\d/.test(total.textContent));
      if (button) {
        if (!ready) {
          button.dataset.bangeLoading = 'true';
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('aria-busy', 'true');
        } else if (button.dataset.bangeLoading) {
          delete button.dataset.bangeLoading;
          button.removeAttribute('aria-disabled');
          button.removeAttribute('aria-busy');
        }
      }
      const modal = document.querySelector('#easysell-modal');
      if (modal?.style.display === 'none') syncEstimate();
      else if (ready && summaryTotal && summaryTotal.textContent !== total.textContent) summaryTotal.textContent = total.textContent;
      if (ready && !readyTracked) { readyTracked = true; track('bange_cod_form_ready'); }
      const phone = document.querySelector('#es-phone');
      if (phone) { phone.inputMode = 'tel'; phone.autocomplete = 'tel'; }
      const name = document.querySelector('#es-first_name');
      if (name) name.autocomplete = 'name';
      const city = document.querySelector('#es-city');
      if (city) city.autocomplete = 'address-level2';
      const address = document.querySelector('#es-address');
      if (address) address.autocomplete = 'street-address';
    };
    const observer = new MutationObserver(() => {
      if (!frame) frame = requestAnimationFrame(() => { frame = 0; sync(); });
    });
    observer.observe(form, { childList: true, subtree: true, characterData: true });
    // The popup is mounted outside product-content. Stop this temporary observer
    // as soon as the app exists; subsequent updates are scoped to the app itself.
    const insertionObserver = new MutationObserver(() => {
      if (document.querySelector('#easysell')) sync();
    });
    if (!document.querySelector('#easysell')) {
      insertionObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => insertionObserver.disconnect(), 60000);
    }
    document.addEventListener('click', (event) => {
      const button = event.target.closest('#es-form-button');
      if (!button) return;
      if (!/\d/.test(button.querySelector('.es-total-placeholder')?.textContent || '')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      track('bange_cod_submit_clicked');
    }, true);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
